import type { TaskPage } from "./input/TaskPage"
import type { TaskResult } from "./input/TaskResult"
import type { TrackedTask } from "./tracking/TrackedTask"

export type TaskResponse = TaskPage | TaskResult | TrackedTask
